module.exports = __webpack_public_path__ + "static/media/editWhite.svg";